import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  findByList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/corporateCulture/findByList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/corporateCulture/findById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/corporateCulture/save`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


}









